import React from 'react'

export default function renderFormikError(error: any): React.ReactNode {
    if (typeof error === 'string') {
      return <div className="text-red-500 text-xs">{error}</div>;
    }
    return null;
}